import request from '@/utils/request'
import { BASE_API, CLINIC_KEY } from '@/utils/consts'

//工作指标
export function getWorkIndex(data) {
  return request(`${BASE_API}/workbench/work_index`, {
    method: 'POST',
    data: {
      ...data,
      clinicId: window.localStorage.getItem(CLINIC_KEY)
    }
  })
}

//工作任务
export function getWorkTask(data) {
  return request(`${BASE_API}/workbench/work_task`, {
    method: 'POST',
    data
  })
}

// 工作指标
export function fetchTargetList(data) {
  return request(`${BASE_API}/target/achieve/list`, {
    method: 'POST',
    data
  })
}

// 员工 成交排名 
export function dealRankByPerson(data) {
  return request(`${BASE_API}/statistics/operation/clinic/consultant/person`, {
    method: 'POST',
    data
  })
}
// 门店 成交排名 
export function dealRankByClinic(data) {
  return request(`${BASE_API}/statistics/operation/platform/consultant/clinic`, {
    method: 'POST',
    data
  })
}
// 员工 新签续费率 
export function renewRateByPerson(data) {
  return request(`${BASE_API}/new_renew/consultant_expense/${data}`, {
    method: 'GET'
  })
}
// 门店 新签续费率 
export function renewRateByClinic(data) {
  return request(`${BASE_API}/new_renew/clinic_expense/${data}`, {
    method: 'GET'
  })
}

export function getConsumeInRankByPerson(data) {
  return request(`${BASE_API}/statistics/operation/clinic/psychologist/person`, {
    method: 'POST',
    data,
  })
}

//查询岗位设置列表
export function getJobPostion(data) {
  return request(`${BASE_API}/job_position/all`, {
    method: 'POST',
    data
  })
}

// 系统公告列表
export function getNoticeList(data) {
  return request(`${BASE_API}/evolve/log/clinic/list`, {
    method: 'POST',
    data
  })
}

// 核心指标v3
export function getWorkIndexV3(data) {
  return request(`${BASE_API}/workbench/clinic/core_index`, {
    method: 'POST',
    data
  })
}

// 核心指标-go
export function getWorkIndexGo(data) {
  return request(`${BASE_API}/workbench/clinic/core_index/from_go`, {
    method: 'POST',
    data
  })
}